import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useTarjetasStore = defineStore('tarjetas', {
  state: () => ({
    tarjetas: [],
    maestro_tarjetas: [],
    search: '',
    perPage: 20,
    page: 1,
    currentPage: 1,
    totalTarjetas: 0,
    totalPages: 1
  }),
  actions: {
    async fetchTarjetas({ page, rows, search, perPage, fecha = null } = {}) {
      try {
        const response = await api.get('/tarjetas', {
          headers: {
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            page: page || this.page,
            rows: rows || this.rows,
            search: search || this.search,
            per_page: perPage || this.perPage,
            fecha: fecha || null
          }
        })
        this.tarjetas = response.data.items
        this.totalTarjetas = response.data.total
        this.totalPages = response.data.pages
        this.perPage = response.data.per_page
        this.page = response.data.page
        return this.tarjetas
      } catch (error) {
        console.error('Error al obtener tarjetas:', error)
        throw error
      }
    },
    async createTarjeta(tarjeta) {
      try {
        const response = await api.post('/tarjetas', tarjeta, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.tarjetas.push(response.data)
        return response.data
      } catch (error) {
        console.error('Error al crear tarjeta:', error)
        throw error
      }
    },
    async updateTarjeta(tarjeta) {
      try {
        const response = await api.put(`/tarjetas/${tarjeta.id}`, tarjeta, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        const index = this.tarjetas.findIndex((t) => t.id === tarjeta.id)
        if (index !== -1) {
          this.tarjetas[index] = response.data
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar tarjeta:', error)
        throw error
      }
    },
    async deleteTarjeta(id) {
      try {
        await api.delete(`/tarjetas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        this.tarjetas = this.tarjetas.filter((t) => t.id !== id)
      } catch (error) {
        console.error('Error al eliminar tarjeta:', error)
        throw error
      }
    },
    setSearch(search) {
      this.search = search
    },
    setRows(rows) {
      this.rows = rows
    },
    setPage(page) {
      this.page = page
    },
    async getTarjeta(id) {
      try {
        if (!id) {
          id = 0
        }
        const response = await api.get(`/tarjetas/${id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        })
        return response.data
      } catch (error) {
        console.error('Error al obtener tarjeta:', error)
        throw error
      }
    }
  }
})
